// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4062":"8d63336f85f0ba3a","5927":"287e51ed08652212","9314":"307879700780bcbe"}[chunkId] + ".js";
};